import { render, staticRenderFns } from "./personal_data.vue?vue&type=template&id=fcb47b4a&scoped=true&"
import script from "./personal_data.vue?vue&type=script&lang=js&"
export * from "./personal_data.vue?vue&type=script&lang=js&"
import style0 from "./personal_data.vue?vue&type=style&index=0&id=fcb47b4a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb47b4a",
  null
  
)

export default component.exports